// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3KLg5","title":"card_title__2gjPd","inActive":"card_inActive__28kHs"};